import ProLayout, { MenuDataItem } from '@ant-design/pro-layout';
import { Protected } from 'components';
import useAuditReportStore from 'components/GAuditReport/hooks';
import { WhitePrismLogo } from 'components/Logo/Logo';
import { menuData, restrictedMenuData } from 'config/menuData';
import { ReactNode, useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useUserInfo } from 'services/api/useSettings';
import { Footer } from './components';
import RightContent from './components/RightContent';

const settings = {
  contentWidth: 'Fluid',
  fixSiderbar: true,
  fixedHeader: true,
  iconfontUrl: '',
  layout: 'top',
  menu: { locale: true },
  title: '',
};

const menuItemRender = (menuItem: MenuDataItem, defaultDom: ReactNode) => {
  if (menuItem.isUrl || menuItem.children || !menuItem.path) {
    return defaultDom;
  }
  return <Link to={menuItem.path}>{defaultDom}</Link>;
};

const rightContentRender = () => <RightContent settings={{ navTheme: 'dark', layout: 'side' }} />;

const GeneralLayout = () => {
  const location = useLocation();

  const setBackFrom = useAuditReportStore((state) => state.setBackFrom);

  useEffect(() => {
    setBackFrom('tradingPartners');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.pathname]);

  const { data: loggedInUserData } = useUserInfo();

  return (
    <Protected>
      <ProLayout
        logo={<WhitePrismLogo />}
        location={location}
        menuDataRender={() =>
          loggedInUserData?.user?.role?.permission?.includes('ACCESS_ANALYTICS_REPORTS')
            ? menuData
            : restrictedMenuData
        }
        menuItemRender={menuItemRender}
        itemRender={() => null}
        footerRender={Footer}
        rightContentRender={rightContentRender}
        contentStyle={{
          backgroundColor: location.pathname.includes('/trace') ? '#fff' : '#f4f4f4',
        }}
        {...settings}
      >
        <Outlet />
      </ProLayout>
    </Protected>
  );
};

export default GeneralLayout;
